import { IonContent } from '@ionic/react';
import DealsCarousel from '../../../../../components-library/carousel/DealsCarousel';
import Header from './components/header';
import FeaturedPosts from './components/FeaturedPosts/FeaturedPosts';
import MostPopularProducts from '../../../features/shared/components/most-popular-products';

const HomeTab = () => {
  return (
    <IonContent fullscreen className="space-y-md [&::part(scroll)]:bg-white [&::part(scroll)]:pb-[140px]">
      <Header />
      <DealsCarousel dealClassName="bg-white border" />
      <MostPopularProducts />
      <FeaturedPosts className="px-md" />
    </IonContent>
  );
};

export default HomeTab;
